// Real employment and education history only.

export const experience = [
  {
    role: "Mobile Application Developer",
    company: "Airavad Web Solutions Pvt Ltd",
    location: "Salem, Tamil Nadu",
    start: "Oct 2024",
    end: "Present",
    current: true,
    summary:
      "Building cross-platform mobile applications with React Native, along with the Node.js and Express services, MongoDB data layer and AWS deployments behind them. Also delivering Next.js web platforms backed by Node.js, Prisma and PostgreSQL.",
    stack: [
      "React Native",
      "JavaScript",
      "Node.js",
      "Express",
      "MongoDB",
      "Next.js",
      "Prisma",
      "PostgreSQL",
      "AWS",
      "Figma",
    ],
  },
  {
    role: "Mobile Application Developer",
    company: "Avanexa Technology",
    location: "Coimbatore, Tamil Nadu",
    start: "Jan 2022",
    end: "Sep 2024",
    current: false,
    summary:
      "Developed React Native apps for Android and iOS, working across UI design in Figma, server-side development with Node.js and Express, MongoDB data modelling and backend deployment to AWS.",
    stack: ["React Native", "JavaScript", "Node.js", "Express", "MongoDB", "AWS", "Figma"],
  },
];

export const education = [
  {
    title: "B.Sc Computer Science",
    institution: "AVS College of Arts and Science",
    affiliation: "Periyar University",
    period: "2018 – 2021",
    result: "85% · First class with distinction",
  },
  {
    title: "Higher Secondary Certificate (HSC)",
    institution: "MPL Boys Hr Sec School",
    affiliation: "State Board",
    period: "2017 – 2018",
    result: "80%",
  },
  {
    title: "Secondary School Leaving Certificate (SSLC)",
    institution: "Shri Swamy Matric Hr Sec School",
    affiliation: "State Board",
    period: "2016",
    result: "84%",
  },
];
